import {Base} from './base'

/**
 * This api contains method used to
 * perform authentication on the server
 * 
 * They are used by vuex store to
 * manage user session
 */
class Event extends Base
{
	// Event id
	id = null

	/**
	 * Default constructor
	 * 
	 * @param {VuexStore} store vuex instance
	 */
	constructor(id, store)
	{
		super(store)

		// Set event id
		this.id = id || null
	}

	/**
	 * 
	 */
	getRange(range)
	{
		return this._get(`/event?` + (new URLSearchParams(range)))
	}

	/**
	 * 
	 */
	getUpcoming()
	{
		return this._get(`/event/upcoming`)
	}

	/**
	 *
	 */
	getSubs(eventid)
	{
		return this._get(`/event/${eventid || this.id}/subs`, {
			edges: 'user'
		})
	}
	
	/**
	 * Subscribe to class event
	 * 
	 * @param {String} id event id
	 */
	enroll()
	{
		return this._post(`/event/${this.id}`)
	}

	/**
	 * Drop out from event
	 * 
	 * @param {String} id event id
	 */
	dropout()
	{
		return this._delete(`/event/${this.id}`)
	}
}

export default Event